import { render, staticRenderFns } from "./radar.vue?vue&type=template&id=65322afa&"
import script from "./radar.vue?vue&type=script&lang=ts&"
export * from "./radar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports